import { Spin } from 'antd';
import React, { useState } from 'react'
import Login from '../UserLogin/Login';
import Signup from '../Signup.js/Signup';
import './Userauth.css'

function Userauth() {
    const [loading, setLoading] = useState(false); // State for loading spinner

    const [isFlipped, setIsFlipped] = useState(false);


    const handleFlip = () => {
      setIsFlipped(!isFlipped);
    };
  
    const setLoad = (newState) => {
      setLoading(newState);
    };
  

    return (
        <>
        <div className='userauth'>

            <Spin spinning={loading}>
                <div className="auth-container">
                    <div className={`card ${isFlipped ? "flipped" : ""}`}>
                        <div className="card-front">
                            <Login onFlip={handleFlip} setLoad={(state)=>setLoad(state)} loading={loading} />
                        </div>
                        <div className="card-back">
                            <Signup onFlip={handleFlip} setLoad={(state)=>setLoad(state)}  loading={loading} />
                        </div>
                    </div>
                </div>
            </Spin>
        </div>

        </>
    )
}

export default Userauth